import image from 'shared/assets/images/integrationsSliders/twillio/twillio.png'
import { type IntegrationDetailsData } from 'entities/Integrations/lib/integrationsDescription'

export const twilio: IntegrationDetailsData = {
  subheadline: 'Bring your own Twilio account for messaging and calling.',
  overview:
    'Salesmsg connects to your existing Twilio account, so your team can send and receive messages and calls using the numbers you already own. This gives teams already invested in Twilio a way to run conversations through Salesmsg without switching numbers or losing existing account setup.',
  keyBenefits: [
    'Use your existing Twilio numbers in Salesmsg',
    'Send and receive texts and calls through your own account',
    'Keep your current Twilio setup and number ownership',
    'Automatically log every message and call for tracking',
  ],
  images: [image],
  docs: '',
}
